var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.023 25.452C19.0732 22.7675 24.5 17.283 24.5 12.25C24.5 9.46523 23.3938 6.79451 21.4246 4.82538C19.4555 2.85625 16.7848 1.75 14 1.75C11.2152 1.75 8.54451 2.85625 6.57538 4.82538C4.60625 6.79451 3.5 9.46523 3.5 12.25C3.5 17.283 8.925 22.7675 11.977 25.452C12.5337 25.9489 13.2538 26.2235 14 26.2235C14.7462 26.2235 15.4663 25.9489 16.023 25.452ZM10.5 12.25C10.5 11.3217 10.8687 10.4315 11.5251 9.77513C12.1815 9.11875 13.0717 8.75 14 8.75C14.9283 8.75 15.8185 9.11875 16.4749 9.77513C17.1313 10.4315 17.5 11.3217 17.5 12.25C17.5 13.1783 17.1313 14.0685 16.4749 14.7249C15.8185 15.3813 14.9283 15.75 14 15.75C13.0717 15.75 12.1815 15.3813 11.5251 14.7249C10.8687 14.0685 10.5 13.1783 10.5 12.25Z",
    fill: "#7DC8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.0619bd3caf0465e3c44f117239fe219f.svg";
export { ForwardRef as ReactComponent };